/**
 * Created by emanuele on 31/01/2017.
 */
import React, {Component} from 'react';


class ErrorMessageTiny extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden:  this.props.error == null
        };
        this.onClick = this.onClick.bind(this);
    }

    onClick(ev){
        this.setState({hidden: !this.state.hidden})
    }

    componentWillReceiveProps(nextProps) {
        this.setState({hidden: nextProps.error == null})
    }

    render() {

        if (this.state.hidden) return <div></div>

        return (
            <div className="ui error message">
                <i className="close icon" onClick={this.onClick}></i>
                <div className="header">{this.props.error.title}</div>
                <p>{this.props.error.msg}</p>
            </div>
        )
    }
}

export default ErrorMessageTiny;


/** WEBPACK FOOTER **
 ** ./src/components/ErrorMessageTiny.jsx
 **/